module.exports = __webpack_public_path__ + "static/media/TPC.f64cb2ec.jpg";